import React from "react";
import { Helmet } from "react-helmet-async";
import webinarBanner from "../assets/WEBINAR-RPA-banner.jpg";
import { FaCube } from "react-icons/fa";
import uipath from "../assets/uipath.jpg";
import sap from "../assets/sap.jpg";
import powerAutomate from "../assets/power-automate.jpg";
import bluePrism from "../assets/blue-prism.jpg";
import automationAnywhere from "../assets/automation-anywhere-1.jpg";
import intellibot from "../assets/intellentbot.jpeg";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  FaRobot,
  FaVideo,
  FaIndustry,
  FaUniversity,
  FaShoppingCart,
  FaWifi,
  FaTv,
  FaHeartbeat,
  FaStore,
  FaBook,
  FaUsers,
  FaCog,
  FaBroadcastTower,
  FaHome,
  FaCalendarAlt,
  FaUserTie
} from "react-icons/fa";

import { AiOutlineRight } from "react-icons/ai";

import rpaBanner from "../assets/RPA-Banner.png";
import rpaImage from "../assets/RPA.png";
import { MdFindInPage } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import { SITE_BASE_URL } from "../data/agenticSeoUtils";
import { RPA_HUB_META, buildRpaHubWebPageJsonLd } from "../data/rpaSeoUtils";

/* ─── Global responsive CSS ──────────────────────────────────────────── */
const RPA_CSS = `
  .rpa-tabs-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
  }
  .rpa-tab-item {
    background: rgba(48, 128, 120, 0.28);
    border: 1px solid rgba(0,0,0,0.10);
    min-height: 58px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    gap: 10px;
  }
  .rpa-tab-label {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    font-family: "Exo", sans-serif;
    white-space: nowrap;
  }

  .rpa-core-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 60px 80px;
    background: #efefef;
    gap: 50px;
  }
  .rpa-core-img {
    max-width: 600px;
    width: 100%;
    object-fit: contain;
    margin-left: -60px;
    margin-top: 20px;
    flex-shrink: 0;
  }
  .rpa-core-text { max-width: 600px; width: 100%; }

  .rpa-diff-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 18px;
  }
  .rpa-diff-card {
    border: 2px solid rgba(255,255,255,0.9);
    border-radius: 8px;
    min-height: 120px;
    padding: 14px 10px;
    background: transparent;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .rpa-services-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
  .rpa-service-card {
    background: #efefef;
    border: 2px solid #4b84d9;
    border-radius: 10px;
    padding: 30px 34px;
    min-height: 300px;
    display: flex;
    flex-direction: column;
  }

  .rpa-usecases-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 18px;
  }
  .rpa-usecase-item {
    background: rgba(0,0,0,0.18);
    border-radius: 10px;
    min-height: 72px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    cursor: pointer;
    transition: 0.3s ease;
  }

  .rpa-partnerships-section {
    background: #2fb7a4;
    padding: 90px 30px 100px;
  }
  .rpa-partnerships-grid {
    display: grid;
    grid-template-columns: 320px 1fr;
    gap: 40px;
    align-items: start;
  }
  .rpa-partnerships-logos {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }

  .rpa-casestudies-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    width: 100%;
  }

  .rpa-videos-section {
    background: #efefef;
    padding: 55px 40px;
  }
  .rpa-videos-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(80px, 1fr));
    gap: 26px;
  }

  /* ── Small desktop / large tablet ≤ 1100px ── */
  @media (max-width: 1100px) {
    .rpa-diff-grid { grid-template-columns: repeat(3, 1fr) !important; }
  }

  /* ── Tablet ≤ 900px ── */
  @media (max-width: 900px) {
    .rpa-tabs-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .rpa-core-inner { flex-direction: column !important; padding: 40px 24px !important; gap: 30px !important; }
    .rpa-core-img { margin-left: 0 !important; margin-top: 0 !important; max-width: 420px !important; }
    .rpa-services-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .rpa-usecases-grid { grid-template-columns: repeat(3, 1fr) !important; }
    .rpa-partnerships-section { padding: 60px 24px 70px !important; }
    .rpa-partnerships-grid { grid-template-columns: 1fr !important; }
    .rpa-casestudies-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .rpa-videos-section { padding: 45px 24px !important; }
    .rpa-videos-grid { grid-template-columns: repeat(2, 1fr) !important; }
  }

  /* ── Mobile ≤ 600px ── */
  @media (max-width: 600px) {
    .rpa-tabs-grid { grid-template-columns: 1fr !important; }
    .rpa-tab-label { white-space: normal !important; font-size: 16px !important; }
    .rpa-diff-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .rpa-services-grid { grid-template-columns: 1fr !important; }
    .rpa-service-card { min-height: auto !important; padding: 26px 22px !important; }
    .rpa-usecases-grid { grid-template-columns: repeat(2, 1fr) !important; }
    .rpa-usecase-item { min-height: auto !important; }
    .rpa-partnerships-logos { grid-template-columns: repeat(2, 1fr) !important; }
    .rpa-casestudies-grid { grid-template-columns: 1fr !important; }
    .rpa-videos-grid { grid-template-columns: 1fr !important; }
  }

  /* ── Small mobile ≤ 420px ── */
  @media (max-width: 420px) {
    .rpa-diff-grid { grid-template-columns: 1fr !important; }
    .rpa-usecases-grid { grid-template-columns: 1fr !important; }
    .rpa-partnerships-logos { grid-template-columns: 1fr !important; }
  }
`;

function RPAPage() {
    const navigate = useNavigate();
    const location = useLocation();

useEffect(() => {
  const hash = location.hash?.replace(/^#/, "");
  const target = hash || location.state?.scrollTo;
  if (target) {
    const el = document.getElementById(target);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 200);
    }
  }
}, [location.hash, location.state]);
  const scrollToSection = (id) => {
    const el = document.getElementById(id);

    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const tabs = [
    {
      label: "RPA Services",
      icon: <FaRobot />,
      id: "services"
    },
    {
      label: "RPA Use Cases",
      icon: <FaRobot />,
      id: "usecases"
    },
   {
  label: "Case Studies",
  icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14 2H7C6.45 2 6 2.45 6 3V21C6 21.55 6.45 22 7 22H17C17.55 22 18 21.55 18 21V6L14 2Z"
        stroke="white"
        strokeWidth="2"
      />
      <path d="M14 2V6H18" stroke="white" strokeWidth="2" />
      <path d="M9 10H15" stroke="white" strokeWidth="1.5" />
      <path d="M9 13H13" stroke="white" strokeWidth="1.5" />
      <circle
        cx="15.5"
        cy="14.5"
        r="3.5"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M18 17L21 20"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  id: "casestudies"
},
    {
      label: "Demo Videos",
      icon: <FaVideo />,
      id: "videos"
    }
  ];
const caseStudies = [
  {
    desc: "This bot raise the invoices by collecting the data from different sources.",
    customer: "Law firm specialized in corporate law, providing services in multiple countries",
    applications: "FedEx, Zoho, API's, Outlook"
  },
  {
    desc: "This bot retrieves the patient clinical details as per the request from legacy system and provides the consolidated view to the physician",
    customer: "Large hospital chain in Denmark",
    applications: "Legacy HMS, Outlook, API's"
  },
  {
    desc: "This bot gets the information from the user through a web application, run multiple operations on multiple websites then provide a consolidated information.",
    customer: "Rental Group Company",
    applications: "Multiple Web Applications, Multiple API's, DB"
  },
  {
    desc: "This bot print the mandatory documents for govt. submission and for archives for about 50 branches of a bank",
    customer: "Largest banking customer in Hongkong",
    applications: "Multiple systems"
  },
  {
    desc: "This bot maintains the inventory required for uninterrupted production in large units",
    customer: "IT service provider in UK",
    applications: "Infor ERP, MS office"
  },
  {
    desc: "This bot receives the purchase requests, read the required information and publish into the end system",
    customer: "Largest supplier for marine and shipping services provider from Philippines",
    applications: "Multiple PDF's, Outlook, In house application"
  }
];
  const useCases = [
  {
    icon: <FaIndustry />,
    label: "Manufacturing",
    link: "/rpa-manufacturing"
  },
  {
    icon: <FaUniversity />,
    label: "Banking",
      link: "/rpa-banking"
  },
 {
  icon: <FaShoppingCart />,
  label: "Logistics",
  link: "/rpa-logistics"
},
  {
  icon: <FaBroadcastTower />,
  label: "Telecommunication",
  link: "/rpa-telecommunication"
},
{
  icon: <FaTv />,
  label: "Entertainment",
  link: "/rpa-media-entertainment"
},
{
  icon: <FaHeartbeat />,
  label: "Healthcare",
  link: "/rpa-healthcare"
},
 {
  icon: <FaHome />,
  label: "Real Estate",
  link: "/rpa-real-estate"
},
  {
 icon: <FaCalendarAlt />,
  label: "Travel & Hospitality",
  link: "/rpa-travel-hospitality"
},
 {
  icon: <FaUsers />,
  label: "Education",
  link: "/rpa-education"
},
 {
  icon: <FaCog />,
  label: "Public Services",
  link: "/robotic-process-automation/government-public-services"
},
  {
  icon: <FaUserTie />,
  label: "Human Resource",
  link: "/rpa-human-resource"
}
];
const videos = [
  {
    title: "GSTR 2A vs Books Automated Reconciliation by AI Robots",
    videoId: "90YlfLRdlBQ",
  },
  {
    title: "SAP automation using RPA",
    videoId: "hBe4EdrLfjA",
  },
  {
    title: "QuickBooks Accounting Processes Automation Using RPA",
    videoId: "wSlyzaLgqw8",
  },
  {
    title: "Robotic Process Automation (RPA) use cases in Accounting and Finance",
    videoId: "i42O0ZIAfss",
  },
  {
    title: "How RPA helps CEO's and CFO's in managing operations efficiently",
    videoId: "Mrwxt0w-m4Q",
  },
  {
    title: "Automated Invoice (PDF/Image) Processing Using Open Source RPA / AI Bots",
    videoId: "P-ePUw4Y8m4",
  },
];
  return (
    <div style={{ overflowX: "hidden" }}>
      <Helmet>
        <html lang="en" />
        <title>{RPA_HUB_META.title}</title>
        <meta name="description" content={RPA_HUB_META.description} />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1" />
        <meta name="author" content="SurensInffotek" />
        <link rel="canonical" href={`${SITE_BASE_URL}${RPA_HUB_META.canonicalPath}`} />
        <link rel="alternate" type="text/plain" title="LLM summary" href={`${SITE_BASE_URL}/llms.txt`} />
        <link rel="alternate" type="text/plain" title="LLM RPA catalog" href={`${SITE_BASE_URL}/llms-rpa.txt`} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="SurensInffotek" />
        <meta property="og:title" content={RPA_HUB_META.title} />
        <meta property="og:description" content={RPA_HUB_META.description} />
        <meta property="og:url" content={`${SITE_BASE_URL}${RPA_HUB_META.canonicalPath}`} />
        <meta property="og:image" content={`${SITE_BASE_URL}/logo.png`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={RPA_HUB_META.title} />
        <meta name="twitter:description" content={RPA_HUB_META.description} />
        <meta name="twitter:image" content={`${SITE_BASE_URL}/logo.png`} />
        <script type="application/ld+json">{JSON.stringify(buildRpaHubWebPageJsonLd())}</script>
      </Helmet>
      <style>{RPA_CSS}</style>


{/* HERO SECTION */}
<div
  style={{
    width: "100%",
    background: "#2fb7a4"
  }}
>
  <img
    src={rpaBanner}
    alt="RPA Banner"
    style={{
      width: "100%",
      display: "block"
    }}
  />
</div>
{/* TOP TABS */}
<div
  style={{
    backgroundImage: `linear-gradient(rgba(43,190,174,0.78), rgba(43,190,174,0.78)), url(${webinarBanner})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    padding: "20px 18px"
  }}
>
  <div className="rpa-tabs-grid">
    {tabs.map((tab, i) => (
      <div
        key={i}
        onClick={() => scrollToSection(tab.id)}
        className="rpa-tab-item"
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px"
          }}
        >
 <div
  style={{
    width: "35px",
    height: "35px",
    background: "rgba(0,0,0,0.18)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    color: "#fff",
    flexShrink: 0
  }}
>
  {tab.label === "RPA Use Cases" ? (
    <FaCube size={20} />
  ) : (
    React.cloneElement(tab.icon, { size: 20 })
  )}
</div>
          <span className="rpa-tab-label">
            {tab.label}
          </span>
        </div>

        <AiOutlineRight
          size={15}
          style={{
            color: "#fff",
            flexShrink: 0
          }}
        />
      </div>
    ))}
  </div>
</div>
      {/* CORE SECTION */}
      <div className="rpa-core-inner">
      <img
  src={rpaImage}
  alt="RPA"
  className="rpa-core-img"
/>

        <div className="rpa-core-text">
          <p
            style={{
              color: "#3976c9",
              fontWeight: "600",
              fontFamily: "Exo, sans-serif",
            }}
          >
            Core Services Portfolio
          </p>

          <h1
            style={{
              fontSize: "clamp(28px, 4vw, 40px)",
              fontWeight: "700",
              lineHeight: "1.1",
                 fontFamily: "Exo, sans-serif",
                color:"#2B2B2B",
              marginBottom: "25px"
            }}
          >
            Robotic Process Automation
          </h1>

          <p style={{ lineHeight: "1.6", fontSize: "15px" }}>
            Using software robots that are easy to configure, require little IT
            expertise and that are simple to train and deploy, Robotic Process
            Automation (RPA) speeds up processing and reduces error rates by
            automating manual tasks.
          </p>

          <p style={{ lineHeight: "1.6", fontSize: "15px"}}>
           We are Hyper Automation or Agentic Process Automation experts, 
           we tend to partner with organizations to assist them to succeed in their objectives from automation initiatives. we offer the top to finish services for automating the Business method also because of the IT operations. we offer services throughout the RPA journey, from the process of the strategy to continuous improvement and innovation, implementation, automation, integration, and support. we‘ve worked across numerous technologies and RPA Vendors like UiPath, Automation anywhere, and BluePrism.</p>
        </div>
      </div>

  {/* DIFFERENTIATORS */}
<div
  style={{
    background: "#264785",
    padding: "22px 16px 60px",
    overflow: "hidden"
  }}
>
  <h1
    style={{
      textAlign: "center",
      color: "#fff",
      fontSize: "clamp(26px, 4.5vw, 42px)",
      fontWeight: "700",
      marginBottom: "36px",
      fontFamily: "Exo, sans-serif",
      lineHeight: "1.15"
    }}
  >
    RPA Differentiators
  </h1>

  <div className="rpa-diff-grid">
    {[
      ["100%", "Certified RPA Developers"],
      ["300+", "Bots across industry (banking,finance etc)"],
      ["120+", "Process Asset Library templates"],
      ["Experience", "Vast experience in building bots"],
      ["Source", "Open Source bot Expertise"],
      ["Testing", "Independent bot testing team"],
      ["Focus", "High Executive Focus"],
      ["Framework", "Library-frameworks,reusable scripts"],
      ["Tools", "Multi Tools Experience"],
      ["Migration", "RPA Migration Expertise"]
    ].map((item, i) => (
      <div
        key={i}
        className="rpa-diff-card"
      >
        <h2
          style={{
            color: "#fff",
            fontSize: "22px",
            fontWeight: "700",
            margin: "0 0 16px",
            lineHeight: "1.1"
          }}
        >
          {item[0]}
        </h2>

        <p
          style={{
            color: "#1fe0c4",
            fontSize: "13px",
            lineHeight: "1.55",
            fontWeight: "600",
            margin: 0,
            maxWidth: "90%",
            fontFamily: "Exo, sans-serif"
          }}
        >
          {item[1]}
        </p>
      </div>
    ))}
  </div>
</div>

{/* SERVICES */}
<div
  id="services"
  style={{
    background: "#efefef",
    padding: "50px 24px 70px"
  }}
>
  <h1
    style={{
      textAlign: "center",
      fontSize: "clamp(26px, 4.5vw, 41px)",
      fontWeight: "700",
      marginBottom: "38px",
      fontFamily: "Exo, sans-serif",
      color: "#111",
      lineHeight: "1.15"
    }}
  >
    RPA Services
  </h1>

  <div className="rpa-services-grid">
    {[
      {
        title: "Consulting",
        icon: require("../assets/S-1.png"),
        points: [
          "Develop strategy & Road map",
          "Implement RPA Process",
          "Proof of concept Development (PoC / MVP)",
          "Identify the most suitable tool"
        ]
      },
      {
        title: "Bots Development",
        icon: require("../assets/S-3.png"),
        points: [
          "Identify the suitable processes",
          "Develop the bots",
          "Scheduling Bots & Orchestration"
        ]
      },
      {
        title: "Independent Bots Testing",
        icon: require("../assets/Bots-Testing.png"),
        points: [
          "Author Positive & Negative test case",
          "Test execution",
          "Test reporting"
        ]
      },
      {
        title: "24*7 Support",
        icon: require("../assets/24.png"),
        points: [
          "Bots maintenance",
          "24 * 7 support for deployed bots"
        ]
      },
      {
        title: "Bots Development",
        icon: require("../assets/Staff.png"),
        points: [
          "Provide RPA certified developers as per the requirement",
          "Short term & Long term skilled resource deployment"
        ]
      },
      {
        title: "RPA Bots Migration",
        icon: require("../assets/RPA-1.png"),
        points: [
          "Understand the Existing Bots",
          "Define Migration strategy",
          "Migrate the bots from one software to another software"
        ]
      }
    ].map((service, i) => (
      <div
        key={i}
        className="rpa-service-card"
      >
       <div
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "110px",
    marginBottom: "12px",
    marginTop: "4px"
  }}
>
  <img
    src={service.icon}
    alt={service.title}
    style={{
      width: "155px",
      height: "155px",
      maxWidth: "100%",
      objectFit: "contain"
    }}
  />
</div>

        <h2
          style={{
            fontSize: "23px",
            fontWeight: "700",
            marginBottom: "22px",
            fontFamily: "Exo, sans-serif",
            color: "#2B2B2B",
            lineHeight: "1.2",
            textAlign: "center"
          }}
        >
          {service.title}
        </h2>

        <ul
          style={{
            paddingLeft: "24px",
            margin: 0,
            marginTop: "18px"
          }}
        >
          {service.points.map((point, index) => (
            <li
              key={index}
              style={{
                fontSize: "15px",
                lineHeight: "1.6",
                color: "#111",
                marginBottom: "2px",
                fontFamily: "Arial"
              }}
            >
              {point}
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
</div>
      {/* USE CASES */}
<div
  id="usecases"
  style={{
background: "linear-gradient(to bottom, #2fb7a4, #1a3a5c)",
    padding: "55px 30px 70px"
  }}
>
  <h1
    style={{
      textAlign: "center",
      color: "#fff",
      fontSize: "clamp(26px, 4.5vw, 41px)",
      fontWeight: "700",
      marginBottom: "42px",
      fontFamily: "Exo, sans-serif",
      lineHeight: "1.15"
    }}
  >
    RPA Use Cases
  </h1>

  <div className="rpa-usecases-grid">
   {useCases.map((item, i) => (
  <div
    key={i}
    onClick={() => item.link && navigate(item.link)}
    className="rpa-usecase-item"
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
            width: "100%"
          }}
        >
          <div
            style={{
              width: "38px",
              height: "38px",
              background: "rgba(0,0,0,0.22)",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              color: "#fff",
              fontSize: "16px"
            }}
          >
            {React.cloneElement(item.icon, { size: 18 })}
          </div>

          <span
            style={{
              color: "#fff",
              fontSize: "15px",
              fontWeight: "500",
              fontFamily: "Exo, sans-serif",
              lineHeight: "1.3"
            }}
          >
            {item.label}
          </span>
        </div>

        <AiOutlineRight
          size={14}
          style={{
            color: "#fff",
            flexShrink: 0
          }}
        />
      </div>
    ))}
  </div>
</div>
{/* PARTNERSHIPS */}
<div className="rpa-partnerships-section">
  <div className="rpa-partnerships-grid">
    {/* LEFT TITLE */}
    <div>
      <h1
        style={{
          fontSize: "clamp(28px, 5vw, 46px)",
          fontWeight: "700",
          color: "#111",
          lineHeight: "1.05",
          fontFamily: "Exo, sans-serif",
          margin: 0
        }}
      >
        Partnerships
      </h1>
    </div>

    {/* RIGHT LOGOS */}
    <div className="rpa-partnerships-logos">
      {[
  uipath,
  sap,
  powerAutomate,
  bluePrism,
  automationAnywhere,
  intellibot
].map((logo, i) => (
        <div
          key={i}
          style={{
            background: "#fff",
            height: "150px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "10px",
            boxSizing: "border-box"
          }}
        >
<img
  src={logo}
  alt="partner"
  style={{
    width: "100%",
    height: logo === intellibot ? "130px" : "120px",
    objectFit: "contain"
  }}
/>
        </div>
      ))}
    </div>
  </div>
</div>
      {/* CASE STUDIES */}
      <div
        id="casestudies"
        style={{
          background: "#efefef",
          padding: "60px 16px"
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontSize: "clamp(28px, 5vw, 50px)",
            marginBottom: "50px",
            fontFamily: "Exo, sans-serif"
          }}
        >
          Case Studies
        </h1>

      <div className="rpa-casestudies-grid">
      {caseStudies.map((item, i) => (
  <div
    key={i}
    style={{
      background: "#3147a5",
      color: "#fff",
      padding: "15px",
      border: "2px solid #6fa8ff",
      borderRadius: "5px",
      lineHeight: "1.8",
      minHeight: "200px"
    }}
  >
       <p style={{ fontSize: "15px" }}>
  {item.desc}
</p>
<p style={{ fontSize: "15px" }}>
  <b>Customer:</b> {item.customer}
</p>

<p style={{ fontSize: "15px" }}>
  <b>Applications:</b> {item.applications}
</p>
            </div>
          ))}
        </div>
      </div>

    
   {/* VIDEOS */}
<div
  id="videos"
  className="rpa-videos-section"
>
  <h1
    style={{
      textAlign: "center",
      fontSize: "clamp(28px, 5vw, 50px)",
      marginBottom: "45px",
      fontFamily: "Exo, sans-serif",
      fontWeight: "700",
      color: "#111"
    }}
  >
    Demo Videos
  </h1>

  <div className="rpa-videos-grid">
    {videos.map((video, i) => (
      <div
        key={i}
        style={{
          border: "2px solid #4b84d9",
          borderRadius: "10px",
          background: "#efefef",
          padding: "10px 10px 12px",
          minHeight: "100px",
        }}
      >
        <h3
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "700",
            color: "#111",
            lineHeight: "1.15",
            marginBottom: "18px",
            fontFamily: "Exo, sans-serif",
            minHeight: "50px"
          }}
        >
          {video.title}
        </h3>

        <div
          style={{
            width: "100%",
            overflow: "hidden",
            borderRadius: "4px"
          }}
        >
          <iframe
           src={`https://www.youtube.com/embed/${video.videoId}`}
            title={video.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              width: "100%",
              height: "230px",
              border: "none",
              display: "block"
            }}
          />
        </div>
      </div>
    ))}
  </div>
</div>
    </div>
  );
}

export default RPAPage;
